<template>
    <div class="app-layout app-content">
        <app-header></app-header>
        <div class="container-fluid">
            <main>
                <router-view></router-view>
            </main>
        </div>
        <footer-menu :isAuth="isAuth" :displayLogin="displayLogin"></footer-menu>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import AuthUtil from '../utils/AuthUtil';
    import AppHeader from '../components/AppHeader/AppHeader.vue';
    import AppFooter from '../components/AppFooter/AppFooter.vue';
    import FooterMenu from '../components/FooterMenu/FooterMenu.vue';

    export default {
        name: 'auth-layout',

        components: {
            AppHeader,
            AppFooter,
            FooterMenu
        },

        data() {
            return {
                isAuth: false,
                pageAuth: false,
                displayLogin: false
            }
        },

        async created() {
            this.isAuth = AuthUtil.isAuth();
            this.pageAuth = this.$route.meta.auth;
            this.isHomePage = this.$route.name === 'home';

            // ※ ログインページ('/login')の場合はクライアントの自動ログイン処理があるため対象外としている。
            if (this.isAuth && this.$route.path !== '/login') {
                this.$router.push('/');
            }
        },

        mounted() {
        },

        methods: {
        }
    }
</script>
